import { Styles } from "react-jss";

import { Theme } from "../../utils/theme";

export const styles = (theme: Theme): Styles => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '32px 16px',
    flexDirection: 'column',
    backgroundColor: theme.backgroundColor as string,
  },
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  projectCard: {
    maxWidth: `calc(30% - ${48 + 32}px)`, // 30%, minus padding and margin,
    '@media (max-width: 1024px)': {
      maxWidth: '100%',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  tooltip: {
    borderRadius: 8,
    fontFamily: theme.fontFamily,
  },
  header: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 1
  },
  external: {
    margin: 8,
    padding: 8
  },
  container: {
    maxWidth: 1280,
    padding: 8,
    margin: '0 auto',
  },
  halfHeight: {
    marginTop: `calc(50vh - ${32 + 130}px)` // 50% of the viewport height, minus the 32px page padding and the height of the element
  },
  projectImg: {
    width: '100%',
    borderRadius: 8,
    marginBottom: 24,
  },
});
